import ProductDetail from './product-detail';

export default ProductDetail;
